import { render, staticRenderFns } from "./menuTitle.vue?vue&type=template&id=5396121e"
import script from "./menuTitle.vue?vue&type=script&lang=js"
export * from "./menuTitle.vue?vue&type=script&lang=js"
import style0 from "./menuTitle.vue?vue&type=style&index=0&id=5396121e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports